export const styles = {
    /* ── Page ── */
    pageWrapper: {
        padding: '24px 28px',
        minHeight: '100vh',
        background: '#f8fafb',
    },

    /* ── Top bar ── */
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '18px',
        flexWrap: 'wrap',
        gap: '12px',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
    },
    btnBack: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '7px 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
    },
    pageTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    pageTitleIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '9px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    pageTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    countBadge: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '2px 10px',
    },

    /* ── Search bar ── */
    searchBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    searchInputWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    searchIcon: {
        position: 'absolute',
        left: '10px',
        color: '#9ca3af',
        pointerEvents: 'none',
    },
    searchInput: {
        paddingLeft: '32px',
        paddingRight: '12px',
        height: '36px',
        width: '240px',
        fontSize: '13px',
        color: '#111827',
        backgroundColor: '#fff',
        border: '1.5px solid #e5e7eb',
        borderRadius: '8px',
        outline: 'none',
        transition: 'border-color 0.15s, box-shadow 0.15s',
    },
    btnSearch: {
        height: '36px',
        padding: '0 18px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        whiteSpace: 'nowrap',
    },
    btnFilterToggle: {
        height: '36px',
        padding: '0 14px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
    },
    btnFilterToggleActive: {
        backgroundColor: '#f0fdf4',
        borderColor: '#1a7d3e',
        color: '#1a7d3e',
    },
    filterBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '18px',
        height: '18px',
        padding: '0 5px',
        fontSize: '11px',
        fontWeight: '700',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        borderRadius: '20px',
    },

    /* ── Filter card ── */
    filterCard: {
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '16px 20px',
        marginBottom: '18px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    },
    filterGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '14px',
        alignItems: 'flex-end',
    },
    filterGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        minWidth: '120px',
    },
    filterGroupWide: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    filterLabel: {
        fontSize: '11.5px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },
    filterSelect: {
        height: '34px',
        padding: '0 10px',
        fontSize: '12.5px',
        color: '#374151',
        backgroundColor: '#fff',
        border: '1.5px solid #e5e7eb',
        borderRadius: '7px',
        outline: 'none',
        cursor: 'pointer',
        minWidth: '120px',
        transition: 'border-color 0.15s',
    },
    locationRow: {
        display: 'flex',
        gap: '8px',
    },
    filterActions: {
        display: 'flex',
        gap: '8px',
        alignItems: 'flex-end',
        marginLeft: 'auto',
        paddingBottom: '0',
    },
    btnFilter: {
        height: '34px',
        padding: '0 22px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '7px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
    btnReset: {
        height: '34px',
        padding: '0 18px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#374151',
        backgroundColor: '#f3f4f6',
        border: '1.5px solid #e5e7eb',
        borderRadius: '7px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },

    /* ── Table card ── */
    tableCard: {
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    tableScroll: {
        overflowX: 'auto',
        maxHeight: '68vh',
        overflowY: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13.5px',
    },
    theadRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
        position: 'sticky',
        top: 0,
        zIndex: 10,
    },
    th: {
        padding: '11px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        userSelect: 'none',
    },
    thNoSort: {
        padding: '11px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
    },
    row: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
    },
    td: {
        padding: '11px 16px',
        color: '#374151',
        fontSize: '13.5px',
        verticalAlign: 'middle',
    },
    indexCell: {
        padding: '11px 16px',
        color: '#9ca3af',
        fontWeight: '600',
        fontSize: '13px',
        verticalAlign: 'middle',
        width: '52px',
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    avatar: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
    },
    nameText: {
        fontWeight: '600',
        color: '#111827',
    },
    emailChip: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f3f4f6',
        borderRadius: '20px',
        fontSize: '12px',
        color: '#374151',
        fontWeight: '500',
    },
    dateBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f3f4f6',
        borderRadius: '20px',
        fontSize: '12px',
        color: '#6b7280',
        fontWeight: '500',
        whiteSpace: 'nowrap',
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
    },
    btnDelete: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #fee2e2',
        background: '#fff5f5',
        color: '#dc2626',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '16px',
    },
    btnAdd: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #d1fae5',
        background: '#f0fdf4',
        color: '#1a7d3e',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '16px',
    },

    /* ── Pagination ── */
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        marginTop: '18px',
        marginBottom: '8px',
    },
    paginationBtn: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '1.5px solid #bbf7d0',
        background: '#fff',
        color: '#1a7d3e',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    },
    paginationBtnDisabled: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '1.5px solid #e5e7eb',
        background: '#f9fafb',
        color: '#d1d5db',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'not-allowed',
        boxShadow: 'none',
    },
    paginationText: {
        fontSize: '13.5px',
        fontWeight: '600',
        color: '#374151',
    },
    paginationHighlight: {
        color: '#1a7d3e',
    },

    /* ── Empty / loader ── */
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '56px 0',
    },
    emptyText: {
        marginTop: '14px',
        fontSize: '14px',
        color: '#9ca3af',
        fontWeight: '500',
    },
    loaderCell: {
        textAlign: 'center',
        padding: '56px 0',
    },
};
